(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-items"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ph-pool-cart-control'))customElements.define('ph-pool-cart-control',class extends HTMLElement{
 connectedCallback(){
  if(this.bound)return;this.bound=true;const button=this.querySelector('button');button.disabled=false;
  button.addEventListener('click',async(event)=>{
   event.preventDefault();event.stopPropagation();if(button.disabled)return;button.disabled=true;
   const root=window.Shopify?.routes?.root||'/';
   try{
    const current=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});if(!current.ok)throw new Error();
    const cart=await current.json();const updates={};
    for(const item of cart.items)if(item.properties?._pool_configuration===this.dataset.reference)updates[item.key]=0;
    if(Object.keys(updates).length){const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});if(!response.ok)throw new Error();}
    window.location.reload();
   }catch(error){this.querySelector('[role="status"]').textContent=this.dataset.error;button.disabled=false;}
  });
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ph-spa-comparison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ph-spa-compare')) customElements.define('ph-spa-compare',class extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    const options = {signal:this.abort.signal};
    this.text = JSON.parse(this.querySelector('[data-spa-text]').textContent);
    this.cards = [...this.querySelectorAll('[data-spa-card]')];
    this.models = this.cards.map(card => ({...JSON.parse(card.querySelector('[data-spa-model]').textContent),card}));
    this.selected = this.selected || new Set();
    this.byId = new Map(this.models.map(model => [String(model.id),model]));
    this.filter = name => this.querySelector('[data-spa-'+name+']');
    const brand = this.filter('brand');
    brand.replaceChildren(new Option(this.text.all_brands,''),...[...new Set(this.models.map(model => model.brand))].filter(Boolean).sort((a,b)=>a.localeCompare(b)).map(value=>new Option(value,value)));
    this.addEventListener('change',event=>{
      if (event.target.matches('[data-spa-select]')) this.choose(event.target.dataset.productId,event.target.checked);
      else this.update();
    },options);
    this.addEventListener('input',event=>{if(event.target.matches('[data-spa-search],[data-spa-min-price],[data-spa-max-price]'))this.update();},options);
    this.querySelectorAll('[data-spa-compare]').forEach(button=>button.addEventListener('click',()=>this.compare(),options));
    this.filter('clear').addEventListener('click',()=>{
      for(const id of [...this.selected])this.choose(id,false);
    },options);
    this.filter('reset-filters').addEventListener('click',()=>{
      for(const name of ['search','brand','seats','min-price','max-price'])this.filter(name).value='';
      this.update();
    },options);
    this.querySelectorAll('[data-spa-controls],[data-spa-selection-control]').forEach(node=>{node.hidden=false;});
    this.update();
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;}
  message(key,values={}) {return this.text[key].replace(/\{(\w+)\}/g,(match,name)=>values[name]??match);}
  choose(id,selected) {
    id=String(id);
    if(!this.byId.has(id))return;
    if(selected&&!this.selected.has(id)&&this.selected.size===4){this.byId.get(id).card.querySelector('[data-spa-select]').checked=false;this.update(this.text.limit);return;}
    const changed=this.selected.has(id)!==selected;
    selected?this.selected.add(id):this.selected.delete(id);
    this.update();
    if(changed)this.dispatchEvent(new CustomEvent('ph:comparison-model-selected',{bubbles:true,detail:{productId:Number(id),selected:Boolean(selected)}}));
  }
  update(notice='') {
    const query=this.filter('search').value.trim().toLocaleLowerCase();
    const brand=this.filter('brand').value;
    const seats=Number(this.filter('seats').value)||null;
    const readPrice=name=>{const value=this.filter(name).value.trim();const number=Number(value);return value!==''&&Number.isFinite(number)&&number>=0?number*100:null;};
    const min=readPrice('min-price'),max=readPrice('max-price');
    const invalid=min!==null&&max!==null&&min>max;
    let visible=0;
    for(const model of this.models){
      const matches=!invalid&&(!query||(model.title+' '+model.brand).toLocaleLowerCase().includes(query))&&(!brand||model.brand===brand)&&(!seats||(model.seatsMax!==null&&model.seatsMax>=seats))&&(min===null||(model.price!==null&&model.price>=min))&&(max===null||(model.price!==null&&model.price<=max));
      model.card.hidden=!matches;
      if(matches)visible++;
      const selected=this.selected.has(String(model.id));
      model.card.dataset.selected=String(selected);
      model.card.querySelector('[data-spa-select]').checked=selected;
    }
    this.filter('status').textContent=notice||(invalid?this.text.invalid_range:this.message('status',{visible,total:this.models.length,selected:this.selected.size}));
    this.filter('mobile-count').textContent=this.message('mobile_count',{selected:this.selected.size});
    this.filter('empty').hidden=visible>0;
    this.querySelectorAll('[data-spa-compare]').forEach(button=>{button.disabled=this.selected.size<2;});
    this.filter('clear').disabled=this.selected.size===0;
    this.filter('chips').replaceChildren(...[...this.selected].map(id=>{
      const model=this.byId.get(id),button=document.createElement('button');
      button.type='button';button.textContent=model.title+' ×';button.setAttribute('aria-label',this.message('remove',{model:model.title}));button.addEventListener('click',()=>this.choose(id,false));return button;
    }));
    if(!this.filter('result').hidden){if(this.selected.size>=2)this.renderTable();else this.filter('result').hidden=true;}
  }
  compare() {
    if(this.selected.size<2){this.filter('status').textContent=this.text.need_two;return;}
    this.renderTable();this.filter('result').hidden=false;
    const heading=this.filter('result-heading');heading.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});heading.focus({preventScroll:true});
    this.dispatchEvent(new CustomEvent('ph:comparison-ready',{bubbles:true,detail:{productIds:[...this.selected].map(Number)}}));
  }
  renderTable() {
    const models=[...this.selected].map(id=>this.byId.get(id));
    const table=document.createElement('table');table.style.minWidth=(145+models.length*220)+'px';
    const head=document.createElement('thead'),header=document.createElement('tr'),label=document.createElement('th');label.scope='col';label.textContent=this.text.model;header.append(label);
    for(const model of models){
      const th=document.createElement('th');th.scope='col';
      if(model.image){const image=document.createElement('img');image.src=model.image;image.alt='';image.width=120;image.height=90;image.loading='lazy';th.append(image);}
      const link=this.productLink(model,model.title);th.append(link);
      const price=document.createElement('strong');price.className='ph-spa-table-price';price.textContent=model.priceText?(model.priceVaries?this.text.from+' ':'')+model.priceText:this.text.price_unknown;th.append(price);
      if(model.compareAtText){const previous=document.createElement('del');previous.textContent=model.compareAtText;th.append(previous);}
      header.append(th);
    }
    head.append(header);table.append(head);
    const body=document.createElement('tbody');
    for(const key of ['brand','seats','dimensions','volume','weight','cleaning']){
      const row=document.createElement('tr'),th=document.createElement('th');th.scope='row';th.textContent=this.text[key];row.append(th);
      for(const model of models){const td=document.createElement('td');td.textContent=model[key]||this.text.unknown;row.append(td);}body.append(row);
    }
    const row=document.createElement('tr'),th=document.createElement('th');th.scope='row';th.textContent=this.text.product_details;row.append(th);
    for(const model of models){const td=document.createElement('td');td.append(this.productLink(model,this.text.product_details));if(model.source){td.append(document.createElement('br'));const link=document.createElement('a');link.href=model.source;link.textContent=this.text.source;td.append(link);}row.append(td);}body.append(row);table.append(body);this.filter('table').replaceChildren(table);
  }
  productLink(model,text){const link=document.createElement('a');link.href=model.url;link.textContent=text;link.dataset.spaProductLink='';link.dataset.productId=String(model.id);return link;}
});
  } catch(e) { console.error(e); }
})();

})();
